import { render, staticRenderFns } from "./DeliveryCampaignGroupsPage.vue?vue&type=template&id=7b45ba3a&scoped=true"
import script from "./DeliveryCampaignGroupsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45ba3a",
  null
  
)

export default component.exports